"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = require("../../openapi");
const EvErrorCode_1 = __importDefault(require("./EvErrorCode"));
let EventError = class EventError extends Error {
    errorCode;
    paramName;
    paramType;
    constructor(errorCode, name, paramType) {
        let message;
        switch (errorCode) {
            case EvErrorCode_1.default.EventRequired:
                message = `Invalid event. ErrorCode: ${errorCode}`;
                break;
            case EvErrorCode_1.default.ClaimsRequired:
                message = `No claims found for this user. ErrorCode: ${errorCode}`;
                break;
            case EvErrorCode_1.default.MissingClaim:
                message = `Missing claim ${name}. ErrorCode: ${errorCode}`;
                break;
            case EvErrorCode_1.default.QueryStringParametersRequired:
                message = `queryStringParameters is required. ErrorCode: ${errorCode}`;
                break;
            case EvErrorCode_1.default.MissingQueryStringParameter:
                message = `Missing parameter ${name}. ErrorCode: ${errorCode}`;
                break;
            case EvErrorCode_1.default.InvalidParameterType:
                message = `Parameter ${name} is not a ${paramType}. ErrorCode: ${errorCode}`;
                break;
            case EvErrorCode_1.default.BodyRequired:
                message = `Body Required. ErrorCode: ${errorCode}`;
                break;
            case EvErrorCode_1.default.InvalidBody:
                message = `Invalid body. ErrorCode: ${errorCode}`;
                if (name) {
                    message = `Invalid body:  Field ${name} is missing or invalid.  ErrorCode: ${errorCode}`;
                }
                break;
            case EvErrorCode_1.default.PathParametersRequired:
                message = `Invalid pathParameters. ErrorCode: ${errorCode}`;
                break;
            case EvErrorCode_1.default.MissingPathParameter:
                message = `Missing path parameter ${name}. ErrorCode: ${errorCode}`;
                break;
            case EvErrorCode_1.default.HeadersRequired:
                message = `Missing headers. ErrorCode: ${errorCode}`;
                break;
            case EvErrorCode_1.default.HeaderRequired:
                message = `Missing header ${name}. ErrorCode: ${errorCode}`;
                break;
            case EvErrorCode_1.default.MissingJwt:
                message = `Missing Jwt. ErrorCode: ${errorCode}`;
                break;
            default:
                message = `Invalid event. ErrorCode: Unknown`;
        }
        super(message);
        this.errorCode = errorCode;
        this.paramName = name;
        this.paramType = paramType;
    }
};
__decorate([
    (0, openapi_1.Schema)({ type: 'number', description: 'The number of the EvErrorCode' })
], EventError.prototype, "errorCode", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'string',
        description: 'The parameter that triggered the error throw',
    })
], EventError.prototype, "paramName", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', description: 'The type of the parameter' })
], EventError.prototype, "paramType", void 0);
EventError = __decorate([
    (0, openapi_1.ClassSchema)({
        description: 'Error thrown by function ValidateEvent on class EventValidator',
    })
], EventError);
exports.default = EventError;
